import { ChevronRightIcon } from "@fluentui/react-icons-mdl2";
import { Button, Col, Form, InputNumber, Row } from "antd";
import { endOfDay, format, startOfDay } from "date-fns";
import { useEffect, useState } from "react";
import { useLazyGetProductCategoryListQuery } from "../../../../redux/api/SystemApi";
import FloatDatePicker from "../../../common/components/FloatDatePicker";
import FloatInput from "../../../common/components/FloatInput";
import { ProductCareSearch } from "../../types";
import { ReactComponent as Expand } from '../../../../assets/images/expand.svg';

interface FilterProps {
    setSubmitValue: React.Dispatch<React.SetStateAction<ProductCareSearch | undefined>>,
    triggerSearch: (submitValue: ProductCareSearch) => void,
    startStatus?: number,
    setPage: React.Dispatch<React.SetStateAction<number>>,
    submitValue?: ProductCareSearch,
}

const CareFilter = ({ setSubmitValue, triggerSearch, startStatus, setPage, submitValue }: FilterProps) => {
    const [form] = Form.useForm();
    const [trigger, response] = useLazyGetProductCategoryListQuery();
    const [seeMore, setSeeMore] = useState(false);
    const [categories, setCategories] = useState<string[]>([]);
    const [startPrices, setStartPrices] = useState<[number, number]>([-1, -1]);
    const [acceptPrices, setAcceptPrices] = useState<[number, number]>([-1, -1]);
    const [startActiveButton, setStartActiveButton] = useState<number>(0);
    const [acceptActiveButton, setAcceptActiveButton] = useState<number>(0);

    useEffect(() => {
        trigger({ page: 0, size: 1000 })
    }, [trigger])

    const onReset = () => {
        setSubmitValue({});
        setCategories([]);
        setStartPrices([-1, -1]);
        setAcceptPrices([-1, -1]);
        setStartActiveButton(0);
        setAcceptActiveButton(0);
        form.resetFields();
    }

    const onValuesChange = (changedValues: any, allValues: any) => {
        let toDateValue = form.getFieldValue("toDate");
        if (changedValues.fromDate && toDateValue && changedValues.fromDate > toDateValue) {
            form.setFieldsValue({
                toDate: ""
            })
        }
    }

    const selectProduct = (type: string) => {
        let newCategories = [...categories];
        let newCategoryIndex = categories.findIndex(item => item === type);
        if (newCategoryIndex === -1) {
            newCategories.push(type);
        } else {
            newCategories.splice(newCategoryIndex, 1);
        }
        setCategories(newCategories);
        let newSubmitValue: ProductCareSearch = {
            ...submitValue,
            page: 0,
            ...newCategories ? { categoryCodes: newCategories } : {},
        }
        triggerSearch(newSubmitValue);
        setSubmitValue(newSubmitValue);
        setPage(1);
    }

    const filterButtonSelect = (startPrice: number, toPrice: number, buttonNum: number, type: string) => {
        let newSubmitValue: ProductCareSearch = {
            ...submitValue,
            page: 0,

        }
        if (type === "start") {
            newSubmitValue = {
                ...newSubmitValue,
                ...startPrice >= 0 && startActiveButton !== buttonNum ? { fromStartPrice: startPrice } : {},
                ...toPrice >= 0 && startActiveButton !== buttonNum ? { toStartPrice: toPrice } : {},
            }
            if (startActiveButton === buttonNum) {
                setStartActiveButton(0);
                setStartPrices([-1, -1]);
            } else {
                setStartActiveButton(buttonNum);
                setStartPrices([startPrice, toPrice]);
            }
        } else if (type === "accept") {
            newSubmitValue = {
                ...newSubmitValue,
                ...startPrice >= 0 && acceptActiveButton !== buttonNum ? { fromAcceptPrice: startPrice } : {},
                ...toPrice >= 0 && acceptActiveButton !== buttonNum ? { toAcceptPrice: toPrice } : {},
            }
            if (acceptActiveButton === buttonNum) {
                setAcceptActiveButton(0);
                setAcceptPrices([-1, -1]);
            } else {
                setAcceptActiveButton(buttonNum);
                setAcceptPrices([startPrice, toPrice]);
            }
        }
        setSubmitValue(newSubmitValue);
        triggerSearch(newSubmitValue)
        setPage(1);

    }

    const onFinish = (values: any) => {
        let canSubmit = true;

        if (canSubmit) {
            let submitValue: ProductCareSearch = {
                page: 0,
                ...startPrices[0] >= 0 ? { fromStartPrice: startPrices[0] } : {},
                ...startPrices[1] >= 0 ? { toStartPrice: startPrices[1] } : {},
                ...acceptPrices[0] >= 0 ? { fromAcceptPrice: acceptPrices[0] } : {},
                ...acceptPrices[1] >= 0 ? { toAcceptPrice: acceptPrices[1] } : {},
                ...values.productName ? { productName: values.productName.trim() } : {},
                ...values.fromDate ? { fromStartAuctionDate: format(startOfDay(values.fromDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
                ...values.toDate ? { toStartAuctionDate: format(endOfDay(values.toDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'+07:00'") } : {},
                ...startStatus ? { startStatus } : {},
                ...categories ? { categoryCodes: categories } : {},
            }

            setSubmitValue(submitValue);
            triggerSearch(submitValue);
            setPage(1);
        }
    }

    return (
        <Form
            className="custom-form"
            name="register"
            form={form}
            colon={false}
            onValuesChange={onValuesChange}
            onFinish={onFinish}
            style={{ background: 'white', padding: 15, borderRadius: 15 }}
        >
            <div className="font-size-16 font-bold">Nhóm tài sản</div>
            <Row style={{ marginTop: 5, maxHeight: seeMore ? '100%' : '300px', overflow: 'hidden' }} gutter={[0, 15]}>
                {response.data?.content.map(item => {
                    return (<Col span={24} key={item.categoryId}>
                        <div
                            className={categories.includes(item.productCategoryCode) ? "filter-button active" : "filter-button"}
                            onClick={() => selectProduct(item.productCategoryCode)}
                        >
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {item.name.trim() || "-"}
                            </span>
                        </div>
                    </Col>
                    )
                })}
            </Row>
            <Row style={{ marginTop: 5 }} gutter={[0, 15]}>
                <Col span={24}>
                    {!seeMore && <div className="see-more-productGroup" onClick={() => setSeeMore(true)}>
                        <span>Xem thêm</span>
                        <Expand style={{ height: 20, color: 'black', marginLeft: 10 }} />
                    </div>}
                    {seeMore && <div className="see-more-productGroup" onClick={() => setSeeMore(false)}>
                        <span>Rút gọn</span>
                        <Expand style={{ height: 20, color: 'black', marginLeft: 10, transform: 'rotate(180deg)' }} />
                    </div>}
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Giá khởi điểm (VNĐ)</div>
            <Row style={{ marginTop: 5 }} gutter={[0, 15]}>
                <Col span={24}>
                    <div
                        className={startActiveButton !== 1 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(0, 100000000, 1, "start")}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 0
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 100 triệu
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={startActiveButton !== 2 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(100000000, 500000000, 2, "start")}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 100 triệu
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 500 triệu
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={startActiveButton !== 3 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(500000000, 1000000000, 3, "start")}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 500 triệu
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 01 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={startActiveButton !== 4 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(1000000000, 10000000000, 4, "start")} >
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 01 tỷ
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 10 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={startActiveButton !== 5 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(1000000000, 50000000000, 5, "start")} >
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 10 tỷ
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 50 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={startActiveButton !== 6 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(50000000000, -1, 6, "start")} >
                        Từ trên 50 tỷ
                    </div>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Giá trúng đấu giá (VNĐ)</div>
            <Row style={{ marginTop: 5 }} gutter={[0, 15]}>
                <Col span={24}>
                    <div
                        className={acceptActiveButton !== 1 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(0, 100000000, 1, "accept")}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 0
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 100 triệu
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={acceptActiveButton !== 2 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(100000000, 500000000, 2, "accept")}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 100 triệu
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 500 triệu
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={acceptActiveButton !== 3 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(500000000, 1000000000, 3, "accept")}>
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 500 triệu
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 01 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={acceptActiveButton !== 4 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(1000000000, 10000000000, 4, "accept")} >
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 01 tỷ
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 10 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={acceptActiveButton !== 5 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(1000000000, 50000000000, 5, "accept")} >
                        <Row align="middle" justify="space-between" style={{ width: '100%' }}>
                            <Col span={10}>
                                Từ 10 tỷ
                            </Col>
                            <Col span={4}>
                                <ChevronRightIcon />
                            </Col>
                            <Col span={10}>
                                Đến 50 tỷ
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <div
                        className={acceptActiveButton !== 6 ? "filter-button" : "filter-button active"}
                        onClick={() => filterButtonSelect(50000000000, -1, 6, "accept")} >
                        Từ trên 50 tỷ
                    </div>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Thời gian đấu giá</div>
            <Row style={{ marginTop: 5 }} gutter={10}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="fromDate"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker label="" placeholder="Từ ngày" className="filter-picker" allowClear />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="toDate"
                        style={{ marginBottom: 0 }}>
                        <FloatDatePicker
                            allowClear
                            label=""
                            placeholder="Đến ngày"
                            className="filter-picker"
                            disabledDate={(current) => {
                                return current && current < form.getFieldValue("fromDate")
                            }} />
                    </Form.Item>
                </Col>
            </Row>

            <div className="font-size-16 font-bold" style={{ marginTop: 25 }}>Tên tài sản</div>
            <Row style={{ marginTop: 5 }}>
                <Col span={24}>
                    <Form.Item
                        name="productName"
                        style={{ marginBottom: 0 }}>
                        <FloatInput label="" placeholder="Nhập tên tài sản cần tìm" className="filter-input" allowClear maxLength={200} />
                    </Form.Item>
                </Col>
            </Row>

            <Row style={{ marginTop: 30 }} align="middle" gutter={10}>
                <Col span={12}>
                    <Button className="button-gray" style={{ height: 45 }} block onClick={onReset}>NHẬP LẠI</Button>
                </Col>
                <Col span={12}>
                    <Button className="button-light-yellow" style={{ height: 45 }} block htmlType="submit">TÌM KIẾM</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default CareFilter;